/** 事業所検索条件 */
export interface OfficeSearchCondition {
  /** 企業コード */
  co_code: string;
  /** 法人名 */
  co_name: string;
  /** 事業所コード */
  kst_no: string;
  /** 事業所名 */
  office_name: string;
}

export const DefaultOfficeSearchCondition = (): OfficeSearchCondition => ({
  co_code: "",
  co_name: "",
  kst_no: "",
  office_name: "",
});

/** 事業所一覧データ */
export interface OfficeItem {
  /** 契約ID */
  agreement_id: number;
  /** 企業コード */
  co_code: string;
  /** 法人名 */
  co_name: string;
  /** 事業所ID */
  office_id: number;
  /** 事業所コード */
  kst_no: string;
  /** 事業所名 */
  office_name: string;
  /** 事業所区分 1:主たる事業所 2:サテライト */
  office_div: number;
}

export const DefaultOfficeItem = (): OfficeItem => ({
  agreement_id: 0,
  co_code: "",
  co_name: "",
  office_id: 0,
  kst_no: "",
  office_name: "",
  office_div: 0,
});

/** 指示書データ */
export interface IndicateItem {
  /** 指示書種類 1:訪問看護指示書 2:精神科訪問看護指示書 3:特別訪問看護指示書 4:精神科特別訪問看護指示書 5:訪問看護点滴注射指示書 */
  indicate_div: number;
  /** 指示書名 */
  indicate_name: string;
  /** 主傷病 */
  main_disease: string;
  /** 病状・治療状態 */
  medical_condition: string;
  /** 別表7 */
  beppyo7: string;
  /** 別表8 */
  beppyo8: string;
  /** 加算項目 */
  add_items: string[];
  /** 点滴注射指示内容 */
  injection_indicate: string;
  /** 留意事項及び指示事項 */
  injection_remarks: string;
  /** 医師からの指示内容 */
  doctor_indicate: string;
}

export const DefaultIndicateItem = (): IndicateItem => ({
  indicate_div: 0,
  indicate_name: "",
  main_disease: "",
  medical_condition: "",
  beppyo7: "",
  beppyo8: "",
  add_items: [],
  injection_indicate: "",
  injection_remarks: "",
  doctor_indicate: "",
});

/** 利用者詳細データ */
export interface PatientItem {
  /** 利用者ID */
  patient_id: number;
  /** 利用者氏名 */
  patient_name: string;
  /** 利用者氏名ふりがな */
  patient_name_kana: string;
  /** 利用者性別 */
  patient_sex: string;
  /** 利用者年齢 */
  patient_age: number;
  /** 心身の状態 */
  mind_and_body_state: string;
  /** 保険情報 */
  insurance_item: string;
  /** 指示書情報 */
  indicate_items: IndicateItem[];
  /** 記録書2枚数 */
  visit_record_count: number;
  /** 記録書1有無 */
  has_vn_record: number;
  /** PDFパス(記録書1) */
  vn_record_pdf_path: string;
  /** 記録書2有無 */
  has_visit_record: number;
  /** PDFパス(記録書2) */
  visit_record_pdf_path: string;
  /** 報告書有無 */
  has_month_report: number;
  /** PDFパス(報告書) */
  month_report_pdf_path: string;
}

export const DefaultPatientItem = (): PatientItem => ({
  patient_id: 0,
  patient_name: "",
  patient_name_kana: "",
  patient_sex: "",
  patient_age: 0,
  mind_and_body_state: "",
  insurance_item: "",
  indicate_items: [],
  visit_record_count: 0,
  has_vn_record: 0,
  vn_record_pdf_path: "",
  has_visit_record: 0,
  visit_record_pdf_path: "",
  has_month_report: 0,
  month_report_pdf_path: "",
});

/** お試し結果 */
export interface ExperimentRes {
  /** システムメッセージ */
  system_message: string;
  /** プロンプト */
  prompt: string;
  /** 回答 */
  answer: string;
  /** コンテキスト */
  context: string;
}

export const DefaultExperimentRes = (): ExperimentRes => ({
  system_message: "",
  prompt: "",
  answer: "",
  context: "",
});
